@if (initialized && dto) {
    <ei-import-type-full
            [objectIdentifier]="objectIdentifier"
            [uiMode]="uiMode"
            [dto]="dto"
            (onNavigationItems)="handleNavigationItems($event)"
    ></ei-import-type-full>
}
